import React, { useEffect, useState } from "react";

import { Marker, InfoWindow, MarkerClusterer } from "@react-google-maps/api";

import { defaultMarker, greenMark } from "../Icons";
import { useAllContexts } from "../../../../hooks/useAllContexts";
import { formatMapData, handleCenter } from "../../helpers";

const options = {
  imagePath:
    "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
};

const BaseCluster = ({
  data,
  categoryId,
  selectedCategory,
  openInfoWindow,
  selectedItem,
  center,
  zoomLevel,
  rightSideBox,
  showNewRoute,
}) => {
  const [clusterData, setClusterData] = useState(null);
  const [activeMarkerId, setActiveMarkerId] = useState(null);

  const { newRouteData } = useAllContexts();

  useEffect(() => {
    const tempData = data?.map((item) => {
      return formatMapData(
        categoryId,
        item,
        selectedCategory === "infra" || showNewRoute ? true : false
      );
    });
    setClusterData(tempData);

    return () => {
      setClusterData(null);
    };
  }, [data]);

  useEffect(() => {
    if (selectedItem.getItem) {
      center.set({
        lat: parseFloat(
          selectedItem?.getItem?.latitude ?? selectedItem?.getItem?.lat
        ),
        lng: parseFloat(
          selectedItem?.getItem?.longitude ?? selectedItem?.getItem?.lng
        ),
      });
      zoomLevel.set(21);
      setActiveMarkerId(
        selectedItem?.getItem?.id ?? selectedItem?.getItem?.mysensor_id
      );
      openInfoWindow.set(true);
    } else {
      center.set(handleCenter(categoryId, {}));
      zoomLevel.set(15);
    }
  }, [selectedItem.getItem]);

  return (
    <MarkerClusterer options={options} averageCenter>
      {(clusterer) => {
        return clusterData?.map((marker, id) => {
          return (
            <Marker
              noRedraw={true}
              key={`${categoryId}_marker_${
                marker?.id ?? marker?.mysensor_id ?? id
              }`}
              position={
                marker?.position ?? {
                  lat: parseFloat(marker?.lat),
                  lng: parseFloat(marker?.lng),
                }
              }
              clickable
              clusterer={clusterer}
              icon={
                categoryId === "12" ? greenMark : marker?.icon ?? defaultMarker
              }
              onClick={() => {
                openInfoWindow.set(true);
                const tempItem = data.filter(
                  (item) =>
                    (categoryId === "122" ? item?.id : item?.mysensor_id) ===
                    marker?.id
                )[0];

                selectedItem.setItem(tempItem);
                center.set(marker.position);
                zoomLevel.set(21);
                if (
                  (categoryId === "122" &&
                    selectedCategory === "routes" &&
                    !showNewRoute) ||
                  categoryId === "31"
                ) {
                  if (!rightSideBox.isVisible) {
                    rightSideBox.setIsVisible(!rightSideBox.isVisible);
                  }
                }
                setActiveMarkerId(marker?.id ?? marker?.mysensor_id);
              }}
            >
              {openInfoWindow.get && activeMarkerId === marker.id && (
                <InfoWindow
                  position={
                    marker?.position ?? {
                      lat: parseFloat(marker?.lat),
                      lng: parseFloat(marker?.lng),
                    }
                  }
                  onCloseClick={() => {
                    openInfoWindow.set(false);
                    center.set(handleCenter(categoryId, {}));
                    zoomLevel.set(15);
                  }}
                >
                  <div style={{ width: "fit-content", paddingInline: "30px" }}>
                    {categoryId === "4" && (
                      <p>{`#${marker?.subTitle} - ${marker?.title}`}</p>
                    )}

                    {categoryId !== "4" && (
                      <>
                        <p>{marker?.title}</p>
                        <p>{marker?.subTitle}</p>
                      </>
                    )}
                    {categoryId === "122" && showNewRoute && (
                      <>
                        <hr
                          style={{
                            border: "none",
                            borderBottom: "1px solid rgba(0,0,0,0.25)",
                          }}
                        />
                        <p
                          style={{
                            textAlign: "right",
                            fontWeight: "400",
                            color: "blue",
                            cursor: "pointer",
                            marginTop: "6px",
                            borderRadius: "12px",
                          }}
                          onClick={() => {
                            openInfoWindow.set(false);
                            newRouteData?.set("step", marker);
                            zoomLevel.set(15);
                            center.set(handleCenter(categoryId, {}));
                          }}
                        >
                          Επιλογή Υποδομής
                        </p>
                      </>
                    )}
                  </div>
                </InfoWindow>
              )}
            </Marker>
          );
        });
      }}
    </MarkerClusterer>
  );
};

export default BaseCluster;
